const respondToVisibility = (element, callback) => {
    const options = {
        root: null
    };

    var observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            callback(entry.intersectionRatio > 0);
        });
    }, options);

    observer.observe(element);
};

export default respondToVisibility;
